/** Bộ lọc đã áp dụng — số liệu dashboard chỉ đổi theo bộ lọc này, không theo ô đang chọn. */
export interface DashboardAppliedFilter {
  customerOperationCode: string;
  monthKey: string;
}

interface Params {
  /** Ô chọn trường bị khoá (khách hàng/phụ huynh, Khách) — các nhóm đó đã có luồng tự tải riêng. */
  isClientSelectLocked: boolean;
  applied: DashboardAppliedFilter | null;
  /** `YYYY-MM` đang chọn; rỗng khi chưa tải xong danh sách tháng. */
  monthKey: string;
  selectedClientCode?: string;
}

/**
 * Bộ lọc tự áp cho tài khoản chọn được trường (HVS, CQQL) để vào Dashboard là thấy số liệu luôn,
 * không phải bấm Tìm kiếm. Chưa chọn trường thì ra tổng quan toàn hệ thống.
 *
 * Chỉ tự áp khi CHƯA có bộ lọc nào (mới vào màn, hoặc vừa Reset); đã có rồi thì đổi tháng/trường
 * vẫn phải bấm Tìm kiếm mới đổi số. Trả `null` = không tự áp.
 */
export const pickAutoAppliedFilter = ({
  isClientSelectLocked,
  applied,
  monthKey,
  selectedClientCode,
}: Params): DashboardAppliedFilter | null => {
  if (isClientSelectLocked || applied || !monthKey) return null;
  return { customerOperationCode: selectedClientCode ?? '', monthKey };
};
